<template>
  <div
    :style="{ gridArea, ...style, 'box-shadow': removeWhiteSpace }"
    class="kk-designer__cell-theme-letter kk-designer__columnletter"
    :class="{
      'kk-designer__columnletter-active': isColumnActive,
      'kk-designer__columnletter-focused': scopeOnDesigner,
    }"
  >
    {{ columnLabel }}
  </div>
</template>

<script>
import { indexToColumn, indexToRow } from "../../../utils/util";
import DesignerMixin from "../DesignerMixin";
import { ProcessTypes } from "../../../utils/icons";
export default {
  mixins: [DesignerMixin],
  props: ["index", "gridIndex", "scopeOnDesigner", "isColumnActive", "removeWhiteSpace"],
  computed: {
    style() {
      return this.current.type === ProcessTypes.Grid
        ? {
            margin: "0px",
            height: "100%",
            borderBottom: "1px solid #eee",
            borderRight: "1px solid #eee",
            fontSize: "14px",
          }
        : {};
    },
    gridArea() {
      return `1 / ${this.gridIndex + 2}`;
    },
    columnLabel() {
      return indexToColumn(this.index);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables.less";

.kk-designer__columnletter {
  height: 25px;
  margin: 0 0.2rem;
  display: grid;
  border: 2px solid transparent;
  border-radius: 0;
  pointer-events: auto; // This is because of custom cursor.
  position: sticky;
  top: 0;
  z-index: 20;
  box-shadow: 0.5rem 0px 0px 0px @kk-color-designer-background;

  &-active {
    background-color: #ececec;
  }
  &-focused {
    color: @kk-color-gray;
  }
}
</style>
